import { Observable } from 'rxjs';
import { IMachineTotals } from 'app/models';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-machine-totals',
  templateUrl: 'machine.totals.component.html',
  styleUrls: ['machine.totals.component.scss'],
})
export class MachineTotalsComponent {
  @Input()
  selectedMachineTotals$: Observable<IMachineTotals> | null = null;
}
